/**
 * Get the aid cookie value
 *
 * @returns {string} aid cookie value
 */
const getAidCookie = () => {
  const value = `; ${document.cookie}`;
  const parts = value.split('; aid=');
  let parsed = '';
  if (parts.length === 2) {
    parsed = parts.pop().split(';').shift();
  }
  return parsed;
};

/**
 * Get the aid value from the query if not already set on cookie
 *
 * @returns {string|null} aid value from query string or cookie
 */
const getAidElementFromQueryString = () => {
  const isAidCookie = getAidCookie();
  if (isAidCookie) {
    return null;
  }

  const queryString = window.location.toString().split('?')[1];

  let aidElement = null;
  if (queryString) {
    const queryArr = queryString.split('&');
    const aid = queryArr.find(element => element.split('=')[0] === 'aid');
    aidElement = aid ? aid.split('=')[1] : null;
  }

  return aidElement;
};

/**
 * Set the aid cookie for the visit
 */
function setAidCookie() {
  const cookieValue = getAidElementFromQueryString();
  const date = new Date();
  date.setTime(date.getTime() + 24 * 60 * 60 * 1000 * 120);
  const expires = `expires=${date.toGMTString()}`;
  if (cookieValue) {
    document.cookie = `aid=${cookieValue};${expires};path=/`;
  }
}

export { setAidCookie };
export default setAidCookie;
